import { FeedbackControllerService } from 'shared/api/generatedApi/services/FeedbackControllerService';
import { FeedbackRequestDto } from 'shared/api';

export const feedbackApi = {
  getAllFeedbacks: () => FeedbackControllerService.findAllFeedbacks(),
  getFeedbackById: (id: number) => FeedbackControllerService.findFeedbackById(id),
  createFeedback: (data: FeedbackRequestDto) => FeedbackControllerService.createFeedback(data),
  updateFeedback: (id: number, data: FeedbackRequestDto) => FeedbackControllerService.updateFeedback(id, data),
  deleteFeedback: (id: number) => FeedbackControllerService.deleteFeedback(id),
  getFeedbacksByUserId: (userId: number) => FeedbackControllerService.findFeedbacksByUserId(userId),
};
